import { Box, Typography } from "@mui/material";
import React from "react";
import mail from "../../../../assets/mail.svg";
import phone from "../../../../assets/phone.svg";
import ContactComponentStyles from "./ContactComponentStyles";
import { businessAddress } from "../../../../constants/Constants";
import { useAppSelector } from "../../../../store/hooks";
import { useTranslation } from "react-i18next";

const ContactButtonComponent: React.FC = () => {
  const { policyDetailsHeader } = useAppSelector(
    (state) => state.policyDetails
  );

  const { t } = useTranslation();

  return (
    <Box sx={ContactComponentStyles.contactContainer}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <Typography variant="body1" sx={ContactComponentStyles.heading}>
          {t("Agent Details")}
        </Typography>
        <Typography variant="body1" sx={ContactComponentStyles.content}>
          {policyDetailsHeader?.producerDetails.nameInfo}
        </Typography>
        <Box sx={ContactComponentStyles.contactContactNumber}>
          <Box sx={ContactComponentStyles.contactPhoneLogo}>
            {<img src={phone} alt="Phone" />}
          </Box>
          <Typography variant="body1" sx={ContactComponentStyles.contactNumber}>
            {policyDetailsHeader?.producerDetails.phoneInfo}
          </Typography>
        </Box>
        <Box sx={ContactComponentStyles.contactContactNumber}>
          <Box sx={ContactComponentStyles.contactMailLogo}>
            {<img src={mail} alt="Mail" />}
          </Box>
          <Typography sx={ContactComponentStyles.contactNumber}>
            {policyDetailsHeader?.producerDetails.emailInfo}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "grid", gap: "8px" }}>
        <Box>
          <Typography sx={ContactComponentStyles.heading}>
            {t("Agency Name")}
          </Typography>
          <Typography sx={ContactComponentStyles.contactInsuranceCompany}>
            {policyDetailsHeader?.producerDetails.agencyName}
          </Typography>
        </Box>
        <Box>
          <Typography sx={ContactComponentStyles.contactBusinessAddress}>
            {t(businessAddress)}
          </Typography>
          <Typography sx={ContactComponentStyles.contactAddress}>
            {`${policyDetailsHeader?.producerDetails?.address?.addr1} ${policyDetailsHeader?.producerDetails?.address?.city} ${policyDetailsHeader?.producerDetails?.address?.stateProvCd} ${policyDetailsHeader?.producerDetails?.address?.regionISOCd}`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ContactButtonComponent;
